import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

export const orderUploadFile = createAsyncThunk("orderUploadFile", async (data, { rejectWithValue }) => {
	try {
		const token = localStorage.getItem("auth_token");
		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				Accept: "application/json",
			},
		};
		const formData = new FormData();
		formData.append("file", data);
		const response = await axiosHttp.post(`order/file/create`, formData, config);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const OrderUploadSlice = createSlice({
	name: "OrderUploadSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	reducers: {
		resetOrderUploadState: (state) => {
			state.isLoading = false;
			state.error = false;
			state.data = null;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(orderUploadFile.pending, (state, action) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(orderUploadFile.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(orderUploadFile.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
			state.data = null;
		});
	},
});

export const { resetOrderUploadState } = OrderUploadSlice.actions;
export default OrderUploadSlice.reducer;
